/**
*
* RedCountdown
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment-timezone';

import Wrapper from 'components/Templates/dynamics/Wrapper';

import defaultTextValues from './defaultTextValues';


class RedCountdown extends React.PureComponent {
  constructor(props) {
    super();

    this._isMounted = false;

    this.calculateTimeLeft = this.calculateTimeLeft.bind(this);
    this._timer;

    this.state = {
      timeLeft: {}
    };
  }

  calculateTimeLeft() {

    if (!this._isMounted) return;

    const {
      defaultValues,
      commonData
    } = this.props;

    const { 
      componentPayload
    } = commonData;

    const {
      customCountdownDate
    } = componentPayload;


    if (this.state.timeLeft.days === '0' && this.state.timeLeft.hours === '0' && this.state.timeLeft.minutes === '0' && this.state.timeLeft.seconds === '0') return;

    const startDate = customCountdownDate && customCountdownDate.date ? customCountdownDate.date : defaultValues.dateFromWithTime ? defaultValues.dateFromWithTime : defaultValues.dateFrom;    
    const { timezone } = this.props.commonProps

    const currentDate = moment().tz(timezone);
    const eventDate = moment(startDate).tz(timezone);
    const difference = moment.duration(eventDate.diff(currentDate));

    const timeLeftData = {
      days: Math.floor(difference.asDays()) > 0 ? Math.floor(difference.asDays()) : '0',
      hours: Math.floor(difference.asHours() % 24) > 0 ? Math.floor(difference.asHours() % 24) : '0',
      minutes: Math.floor((difference.asMinutes() % 1440) % 60) > 0 ? Math.floor((difference.asMinutes() % 1440) % 60) : '0',
      seconds: Math.floor(((difference.asSeconds() % 86400) % 3600) % 60) > 0 ? Math.floor(((difference.asSeconds() % 86400) % 3600) % 60) : '0',
    };
 
    this.setState({
      timeLeft: timeLeftData
    });
  }

  componentDidMount() {
    this._isMounted = true;

    this._timer = setInterval(this.calculateTimeLeft, 1000);

  }

  componentDidUpdate(prevProps) {
    const {
      commonData
    } = this.props;

    const { 
      componentPayload
    } = commonData;

    const {
      customCountdownDate
    } = componentPayload;

    if (customCountdownDate !== prevProps.commonData.componentPayload.customCountdownDate) {
      if (this._timer) clearInterval(this._timer);

      this.setState({
        timeLeft: {}
      }, () => {
        this._timer = setInterval(this.calculateTimeLeft, 1000);
      });
    }

  }



  componentWillUnmount() {
    this._isMounted = false;
    if (this._timer) clearInterval(this._timer);
  }


  render() {

    const {
      commonData,
      openEditor,
      commonProps,
    } = this.props;

    const {
      timeLeft
    } = this.state;

    return (
      <Wrapper
        {...commonProps}
        
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
      >
        <Wrapper
          {...commonProps}
          
          typeOfStyle={'wrapperWithMargin'}
          editorData={
            {
              editorType: 'wrapperWithMargin',
              ...commonData
            }
          }
        >
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'sectionTitle'}
            type={'text'}
            defaultValues={defaultTextValues}
            editorData={
              {
                editorType: 'sectionTitle',
                ...commonData
              }
            }
          />
          <Wrapper
            {...commonProps}
            
            typeOfStyle={'countdownsWrapper'}
            editorData={
              {
                editorType: 'countdownsWrapper',
                ...commonData
              }
            }
          >
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'countdownTile'}
              editorData={
                {
                  editorType: 'countdownTile',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownNumberDays'}
                editorData={
                  {
                    editorType: 'countdownNumberDays',
                    ...commonData
                  }
                }
              >
                {timeLeft.days}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownSubtitleDays'}
                defaultValues={defaultTextValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'countdownSubtitleDays',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'countdownTile'}
              editorData={
                {
                  editorType: 'countdownTile',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownNumberHours'}
                editorData={
                  {
                    editorType: 'countdownNumberHours',
                    ...commonData
                  }
                }
              >
                {timeLeft.hours}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownSubtitleHours'}
                defaultValues={defaultTextValues}
                type={'text'}
                editorData={
                  {
                    editorType: 'countdownSubtitleHours',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'countdownTile'}
              editorData={
                {
                  editorType: 'countdownTile',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownNumberMinutes'}
                editorData={
                  {
                    editorType: 'countdownNumberMinutes',
                    ...commonData
                  }
                }
              >
                {timeLeft.minutes}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownSubtitleMinutes'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'countdownSubtitleMinutes',
                    ...commonData
                  }
                }
              />
            </Wrapper>
            <Wrapper
              {...commonProps}
              
              typeOfStyle={'countdownTile'}
              editorData={
                {
                  editorType: 'countdownTile',
                  ...commonData
                }
              }
            >
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownNumberSeconds'}
                editorData={
                  {
                    editorType: 'countdownNumberSeconds',
                    ...commonData
                  }
                }
              >
                {timeLeft.seconds}
              </Wrapper>
              <Wrapper
                {...commonProps}
                
                typeOfStyle={'countdownSubtitleSeconds'}
                type={'text'}
                defaultValues={defaultTextValues}
                editorData={
                  {
                    editorType: 'countdownSubtitleSeconds',
                    ...commonData
                  }
                }
              />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );


  }
}

RedCountdown.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  defaultValues: PropTypes.object
};

export default RedCountdown;
